import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Target } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  const baseFeatures = ['6 Módulos completos', '225+ páginas de contenido', 'Acceso de por vida', 'Actualizaciones gratuitas', 'Optimizado para celular y tablet'];
  const maestroFeatures = ['Todo lo del Megapack base, MÁS:', 'Máquinas GYM — Planos y fabricación completa', 'TRAILERS — Construcción profesional paso a paso', 'Megapack Planos Muebles Industriales (225 pág.)', 'RENTABILIDAD Y NÚMEROS — Cuánto y cómo cobrar', 'TÉCNICAS DE VENTAS — Conseguí y cerrá clientes'];
  const comparisonRows = [{
    sit: 'Cliente pide una máquina de GYM',
    sin: 'No tenés los planos ni el proceso',
    con: 'Planos completos listos para fabricar hoy'
  }, {
    sit: 'Presupuestás un trabajo',
    sin: 'Cobrás de oído y perdés plata',
    con: 'Sabés exactamente cuánto cobrar'
  }, {
    sit: 'Cliente pregunta el precio',
    sin: 'No sabés si es caro o barato',
    con: 'Técnica de ventas para cerrar sin regatear'
  }, {
    sit: 'Querés fabricar un trailer',
    sin: 'No sabés por dónde empezar',
    con: 'Sistema paso a paso completo'
  }, {
    sit: 'Competencia te baja el precio',
    sin: 'Bajás el tuyo y perdés rentabilidad',
    con: 'Argumentos de valor para no ceder'
  }, {
    sit: 'Fin de mes en el taller',
    sin: 'No sabés si ganaste o perdiste',
    con: 'Números claros y control total'
  }];
  return <section id="pricing" className="py-24 bg-zinc-900" data-id="element-173">
      <div className="container mx-auto px-4" data-id="element-174">
        <div className="text-center mb-16" data-id="element-175">
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[28px]" data-id="element-176">
            🛒 ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-zinc-200 text-[16px]" data-id="element-177">
            Asegurá tu acceso antes de que termine el contador.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-20" data-id="element-178">
          {/* Opción 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-black rounded-3xl p-8 shadow-2xl border border-zinc-800 flex flex-col h-full relative z-10" data-id="element-179">
            <div className="mb-6" data-id="element-180">
              <p className="text-zinc-400 font-bold uppercase tracking-wider text-sm mb-2" data-id="element-181">
                OPCIÓN 1
              </p>
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-182">
                🔨 MEGAPACK HERRERO ARGENTINO
              </h3>
              <p className="text-zinc-400 font-medium" data-id="element-183">6 Módulos completos</p>
            </div>

            <div className="mb-6 pb-6 border-b border-zinc-800" data-id="element-184"></div>

            <div className="mb-8" data-id="element-185">
              <div className="flex items-end gap-2" data-id="element-186">
                <span className="text-5xl font-black text-white" data-id="element-187">$19.990</span>
                <span className="text-xl font-bold text-zinc-400 mb-1" data-id="element-188">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-189">
              {baseFeatures.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-190">
                  <Check className="w-5 h-5 text-zinc-500 shrink-0 mt-0.5" data-id="element-191" />
                  <span className="text-zinc-300" data-id="element-192">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53707481940286:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-193">
              <Button variant="outline" size="lg" fullWidth withArrow data-id="element-194">
                🔥 QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Opción 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-black rounded-3xl p-8 shadow-2xl border-2 border-amber-400 flex flex-col h-full relative z-10 transform lg:-translate-y-4" data-id="element-195">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-amber-500 text-black font-black px-4 py-1 rounded-full text-sm uppercase tracking-wider flex items-center gap-1 shadow-lg" data-id="element-196">
              <Star className="w-4 h-4 fill-black" data-id="element-197" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-198">
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-199">
                ⚡ MEGAPACK HERRERO ARGENTINO + NIVEL MAESTRO
              </h3>
              <p className="text-amber-300 font-bold" data-id="element-200">
                Todo lo anterior + El nivel profesional completo
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-amber-900/30" data-id="element-201"></div>

            <div className="mb-8" data-id="element-202">
              <div className="flex items-end gap-2" data-id="element-203">
                <span className="text-5xl font-black text-white" data-id="element-204">$27.990</span>
                <span className="text-xl font-bold text-amber-300 mb-1" data-id="element-205">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-206">
              {maestroFeatures.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-207">
                  <Check className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" data-id="element-208" />
                  <span className={i === 0 ? 'text-amber-200 font-bold' : 'text-zinc-100'} data-id="element-209">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53707618484542:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-210">
              <Button variant="primary" size="lg" fullWidth withArrow data-id="element-211">
                ⚡ QUIERO EL MEGAPACK + NIVEL MAESTRO
              </Button>
            </a>
          </motion.div>
        </div>

        {/* Nivel Maestro Details */}
        <div className="max-w-4xl mx-auto" data-id="element-212">
          <div className="text-center mb-10" data-id="element-213">
            <h3 className="text-2xl md:text-3xl font-extrabold text-white flex items-center justify-center gap-2" data-id="element-214">
              <Target className="w-8 h-8 text-amber-400" data-id="element-215" />
              ¿QUÉ AGREGA EL NIVEL MAESTRO?
            </h3>
          </div>

          <div className="overflow-x-auto pb-4 mb-12" data-id="element-216">
            <div className="min-w-[700px]" data-id="element-217">
              <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-218">
                <div className="font-bold text-zinc-400 uppercase text-sm tracking-wider" data-id="element-219">
                  Situación
                </div>
                <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-220">
                  ❌ Sin NIVEL MAESTRO
                </div>
                <div className="font-bold text-amber-400 uppercase text-sm tracking-wider" data-id="element-221">
                  ✅ Con NIVEL MAESTRO
                </div>
              </div>

              <div className="space-y-2" data-id="element-222">
                {comparisonRows.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 bg-black/60 rounded-xl p-4 items-center border border-amber-900/20" data-id="element-223">
                    <div className="text-zinc-300 font-medium text-sm" data-id="element-224">
                      {row.sit}
                    </div>
                    <div className="text-red-300/80 text-sm" data-id="element-225">{row.sin}</div>
                    <div className="text-amber-300 font-medium text-sm" data-id="element-226">
                      {row.con}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="bg-zinc-800/50 rounded-2xl p-6 md:p-8 border border-zinc-700" data-id="element-227">
            <h4 className="font-bold text-amber-400 mb-6 uppercase tracking-wider" data-id="element-228">
              EL NIVEL MAESTRO INCLUYE:
            </h4>
            <div className="space-y-6" data-id="element-229">
              <div data-id="element-230">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-231">
                  <span className="text-amber-400" data-id="element-232">🏋️</span> MÁQUINAS GYM
                </p>
                <p className="text-zinc-300 text-sm" data-id="element-233">
                  Cómo fabricar equipamiento de gimnasio desde cero. Planos,
                  materiales, medidas y procesos detallados. Un producto con
                  demanda constante, márgenes altos y clientes que vuelven.
                </p>
              </div>
              <div data-id="element-234">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-235">
                  <span className="text-amber-400" data-id="element-236">🚛</span> TRAILERS
                </p>
                <p className="text-zinc-300 text-sm" data-id="element-237">
                  Construcción de trailers paso a paso. El trabajo más rentable
                  que puede hacer un taller. Todo el sistema para fabricarlos
                  correctamente, con seguridad y cobrarlos lo que realmente
                  valen.
                </p>
              </div>
              <div data-id="element-238">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-239">
                  <span className="text-amber-400" data-id="element-240">📐</span> MEGAPACK PLANOS
                  MUEBLES INDUSTRIALES (225 pág.)
                </p>
                <p className="text-zinc-300 text-sm" data-id="element-241">
                  225 páginas de planos listos para producir. Muebles
                  industriales que se venden solos en el mercado actual.
                  Medidas, materiales y procesos detallados para cada modelo.
                </p>
              </div>
              <div data-id="element-242">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-243">
                  <span className="text-amber-400" data-id="element-244">💰</span> RENTABILIDAD Y
                  NÚMEROS
                </p>
                <p className="text-zinc-300 text-sm" data-id="element-245">
                  Cómo costear cada trabajo con precisión. Cuánto cobrar por
                  hora, por material, por mano de obra. El módulo que más plata
                  te va a dar — porque te muestra todo lo que estás regalando
                  hoy sin darte cuenta.
                </p>
              </div>
              <div data-id="element-246">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-247">
                  <span className="text-amber-400" data-id="element-248">🤝</span> TÉCNICAS DE VENTAS
                </p>
                <p className="text-zinc-300 text-sm" data-id="element-249">
                  Cómo conseguir clientes, cómo presentar presupuestos, cómo
                  cerrar ventas sin regatear. El sistema de ventas pensado
                  específicamente para herreros argentinos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}